<template>
    <div>
        <div v-if="hasItems" v-cloak>
            <kendo-tabstrip ref="relatedFormTabstrip"
                            v-if="formsLoaded"
                            @activate="onTabActivate"
                            :scrollable="true"
                            :scrollable-distance="100">
                <ul>
                    <li v-for="(form, index) in forms"
                        :key="form.formToRegisterEntityId"
                        :id="form.uid"
                        :class="index === 0 ? 'k-state-active' : ''">
                        {{ isEnVersion ? form.nameEn : form.name }}
                    </li>
                </ul>
                <div v-for="form in forms"
                     :key="form.formToRegisterEntityId">
                    <div v-if="tabIsActive(form.uid)">
                        <form-summary-grid :formToRegisterEntityId="form.formToRegisterEntityId">

                        </form-summary-grid>
                    </div>
                </div>
            </kendo-tabstrip>
        </div>
        <div v-else v-cloak>
            <div class="card">
                <div class="card-header">
                    {{ $t('registers.forms.completed')}}
                </div>
                <div class="card-body">
                    <h4 class="card-title">{{ $t('missingData') }}</h4>
                </div>
            </div>
        </div>
    </div>

</template>


<script>
    import FormSummaryGrid from "./FormSummaryGrid";
    import { mapGetters } from 'vuex';

    export default {
        name: 'forms-summary',
        components: {
            FormSummaryGrid
        },
        created: function () {

        },
        props: {
            relatedEventId: {
                default: 0,
                type: Number,
                required: true,
            }
        },
        data() {
            return {
                componentName: "FormsSummary",
                formsLoaded: false,
                activeTabs: [],
                forms: []
            }
        },
        methods: {
            loadForms() {
                this.$http.get(`/api/dynamicFormVisualization/formsForEvent/${this.relatedEventId}`)
                    .then((response => {
                        if (response.data.items) {
                            this.forms = response.data.items;
                            if (this.forms && Array.isArray(this.forms) && this.forms.length > 0) {
                                this.activeTabs.push(this.forms[0]["uid"]);
                            }
                        }

                        this.formsLoaded = true;
                    })).catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            onTabActivate(e) {
                const tabId = e.item.id;
                if (!tabId) {
                    return;
                }

                if (!this.activeTabs.includes(tabId)) {
                    this.activeTabs.push(tabId);
                }
            },
            tabIsActive(uid) {
                return this.activeTabs.includes(uid);
            },
            refresh() {

            }
        },
        mounted() {
            this.loadForms();
        },
        computed: {
            ...mapGetters(['isEnVersion']),
            hasItems() {
                return Array.isArray(this.forms) && this.forms.length;
            }
        }
    }
</script>


<style>
</style>
